<template>
    <section class="text-center max-w-xl mx-auto pt-12">
        <BackButton :to="{ name: 'home' }" />
        <Title>Béret</Title>
        <div class="space-y-6 pt-8">
            <button v-if="GameStarted" class="w-full bg-gradient-to-r from-blue-400 to-blue-500 text-white font-bold py-4 px-4 rounded"
                @click="$router.push({ name: 'beret-play' })">
                Continuer la partie
            </button>
            <Counter label="Nombre de joueurs par équipe" v-model="NumberOfPlayersPerTeam" />
            <button class="bg-gradient-to-r from-violet-300 to-violet-400 text-white font-bold py-2 px-4 rounded"
                @click="StartGame(), $router.push({ name: 'beret-play' })">
                Démarrer une nouvelle partie
            </button>
        </div>
    </section>
</template>
<script>
import { mapFields } from '@/models'
import { mapActions, mapState } from 'vuex'
export default {
    computed: {
        ...mapFields('Beret', ['NumberOfPlayersPerTeam']),
        ...mapState('Beret', ['GameStarted'])
    },
    methods: {
        ...mapActions('Beret', ['StartGame'])
    }
}
</script>